import React, { useEffect, useState } from 'react';
import useAuth from "./hooks/use-auth";
import AppRoutes from "./AppRoutes";
import * as tokenStorage from "src/tokenStorage";

const AppRoutesWrapper = () => {
  const { setConsumeRefreshBeforeExpiration } = useAuth();
  const [ loading, setLoading ] = useState(true);
  const token = tokenStorage.getToken();
  const refreshToken = tokenStorage.getRefreshToken();

  useEffect(() => {
    if (token && refreshToken) {
      setConsumeRefreshBeforeExpiration(token, refreshToken);
    }
    setLoading(false);
  }, [])

  if (loading) {
    return null;
  }

  return <AppRoutes />;
}

export default AppRoutesWrapper;

AppRoutesWrapper.propTypes = {}

AppRoutesWrapper.defaultProps = {}